class bhs_hamburger {
    static get selectors() {
      return {
        //offsetAnimation: '800'
      };
    }
    static init() {
  
      var forEach = function(t, o, r) {
        if ("[object Object]" === Object.prototype.toString.call(t))
          for (var c in t)
            Object.prototype.hasOwnProperty.call(t, c) && o.call(r, t[c], c, t);
        else for (var e = 0, l = t.length; l > e; e++) o.call(r, t[e], e, t);
      };
    
      var hamburgers = document.querySelectorAll(".hamburger");
      if (hamburgers.length > 0) {
        forEach(hamburgers, function(hamburger) {
          hamburger.addEventListener(
            "click",
            function() {
              this.classList.toggle("is-active");
    
              $(".bhs-nav-sidedoor").toggleClass("active");
            },
            false
          );
        });
      }

      $(".bhs-hero-image-downArrow").click(function() {
        $("html, body").animate(
          {
            scrollTop: $($.attr(this, "href")).offset().top - 50
          },
          500
        );
        return false;
      });

    }
  }
  module.exports = bhs_hamburger;
  